import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";
import { toast } from "sonner";
import { initials, ageDisplay } from "@/lib/format";

const SPECIALIZATIONS = [
  "Cardiology", "Dermatology", "Endocrinology", "Gastroenterology", "General Practice",
  "Gynecology", "Neurology", "Oncology", "Ophthalmology", "Orthopedics",
  "Pediatrics", "Psychiatry", "Pulmonology", "Radiology", "Urology",
];

export default function ReferPatientDialog({ open, onOpenChange, patient, onDone }) {
  const [specialization, setSpecialization] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!patient) return;
    if (!specialization) return toast.error("Pick a specialization");
    setBusy(true);
    try {
      await api.post("/referrals", {
        patient_id: patient.id, specialization, doctor_name: doctorName, notes,
      });
      toast.success("Referral sent");
      onDone?.();
      onOpenChange(false);
      setSpecialization(""); setDoctorName(""); setNotes("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to refer");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-[24px] max-w-lg" data-testid="refer-patient-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold tracking-tight text-[#0A4C36]" style={{ fontFamily: "Instrument Sans" }}>Refer patient</DialogTitle>
        </DialogHeader>
        {patient && (
          <div className="flex items-center gap-3 mt-2 mb-4">
            <div className="w-12 h-12 rounded-full bg-[#0A4C36]/8 text-[#0A4C36] flex items-center justify-center font-semibold">
              {initials(patient.name)}
            </div>
            <div>
              <div className="font-semibold text-[#1F2A24]">{patient.name}</div>
              <div className="text-xs text-[#8A9992]">{patient.gender} · {ageDisplay(patient)}</div>
            </div>
          </div>
        )}
        <div className="space-y-4">
          <div>
            <label className="field-label block mb-2">Doctor specialization</label>
            <select data-testid="referral-specialization" value={specialization} onChange={(e) => setSpecialization(e.target.value)} className="input-clean">
              <option value="">Select specialization</option>
              {SPECIALIZATIONS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="field-label block mb-2">Select doctor</label>
            <input data-testid="referral-doctor" value={doctorName} onChange={(e) => setDoctorName(e.target.value)} className="input-clean" placeholder="Doctor's name (optional)" />
          </div>
          <div>
            <label className="field-label block mb-2">Notes</label>
            <textarea data-testid="referral-notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="input-clean min-h-[90px] py-3" placeholder="Add some notes to the referred doctor" />
          </div>
          <div className="flex justify-end pt-2">
            <button data-testid="referral-submit" disabled={busy} onClick={submit} className="btn-emerald">
              {busy ? "Sending…" : "Send referral"}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
